import type { CardDesignTokens, CardTokenSections } from '@primeuix/themes/types/card';

// Rebrand 2026 (DS): cards are a hairline border, no shadow (the border itself
// lives in cleverly-overrides.scss — PrimeNG cards have no border token).
export const root: CardTokenSections.Root = {
    background: '{content.background}',
    borderRadius: '{borderRadius.lg}',
    color: '{text.color}',
    shadow: 'none'
};

export const body: CardTokenSections.Body = {
    padding: '18px',
    gap: '10px'
};

export const caption: CardTokenSections.Caption = {
    gap: '4px'
};

export const title: CardTokenSections.Title = {
    fontSize: '1.125rem',
    fontWeight: '600'
};

export const subtitle: CardTokenSections.Subtitle = {
    color: '{text.mutedColor}'
};

export default {
    root,
    body,
    caption,
    title,
    subtitle
} satisfies CardDesignTokens;
